var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        {
          attrs: { "right-fixed": "" },
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v(_vm._s(_vm.$t("backText"))),
                  ]),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSave } },
                    [_vm._v(_vm._s(_vm.$t("okText")))]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v(_vm._s(_vm.$t("RoleManagement.common.menu")) + " ")]
      ),
      _c(
        "el-row",
        [
          _c("BjInput", {
            staticClass: "mb16",
            staticStyle: { width: "400px" },
            attrs: {
              maxlength: _vm.MAX_LENGTH.DEFAULT,
              placeholder: _vm.$t("RoleManagement.child.filter"),
            },
            model: {
              value: _vm.filterText,
              callback: function ($$v) {
                _vm.filterText = $$v
              },
              expression: "filterText",
            },
          }),
        ],
        1
      ),
      _c("el-tree", {
        ref: "tree",
        attrs: {
          data: _vm.data,
          "show-checkbox": "",
          "node-key": "id",
          "highlight-current": "",
          props: _vm.defaultProps,
          "filter-node-method": _vm.filterNode,
          "default-checked-keys": _vm.checkedList,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var node = ref.node
              var data = ref.data
              return _c("span", { staticClass: "custom-tree-node" }, [
                _c(
                  "span",
                  [
                    _c(
                      "el-tag",
                      {
                        staticClass: "el-tag-left",
                        attrs: {
                          type: _vm.SETTING_PERMISSION_TYPE_COLOR_LIST.bjGet(
                            data.permissionType
                          ),
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              _vm.SETTING_PERMISSION_TYPE_LIST.bjGet(
                                data.permissionType
                              )
                            )
                          )
                        ),
                      ]
                    ),
                    _vm._v(_vm._s(node.label)),
                  ],
                  1
                ),
              ])
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }